<template>
  <modal name="message" @opened="opened" :draggable="'.header'" :reset="true" :classes="['messagebox','generalbox']"
         :adaptive="true"
         :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>消息</h2>
    </div>

    <div @scroll="msgListScroll" ref="msgListContent" class="content">
      <div class="search-container">
        <div class="search">
          <multiselect v-model="appInfo"
                       :options="systemList"
                       placeholder="请选择应用名称"
                       :multiple="false"
                       :show-labels="false"
                       :clear-on-select="false"
                       :close-on-select="true"
                       :allow-empty="true"
                       :taggable="true"
                       :label="'name'"
                       @select="appSelect"
          ></multiselect>
          <input v-model="keyword" type="text"/>
          <button @click="filterMsgList">查询</button>

          <button @click="resetMsgFilter" class="reset">重置</button>
          <button @click="setAllSeen" class="allseen">全部已读</button>
        </div>
      </div>

      <ul v-if="isShowList" class="timeline-list">
        <div v-if="!msgList.length" class="empty">
          消息列表为空~
        </div>
        <li v-for="(msgGroup,index) in msgList">
          <h3><span v-if="msgList[index-1] ? msgGroup.year!==msgList[index-1].year:true"
                    class="year">{{msgGroup.year}}年</span><span class="month"><span><i
              class="iconfont icon-weizhi"></i></span>{{msgGroup.month}}月</span></h3>
          <ul>
            <li :class="{'seen':msg.read}" v-for="msg in msgGroup.data">
              <div class="info">
                <p>{{msg.sysName}}</p>
                <p>{{msg.time}}</p>
                <span></span>
              </div>
              <p @click="showDetail(msg.id,msg,$event)" :class="{'new':msg.state===1,'seen':msg.state===0}">
                {{msg.title}}</p>
              <ul @click="showDetail(msg.id,msg,$event)">
                <li class="showContentBtn">查看详情</li>
                <li @click="toProfileVerifyHandle(msg)" v-if="msg.type===5 || msg.type===8">去操作</li>
                <li v-if="false" class="interact">与TA互动</li>
              </ul>
              <div class="msgContent">
                sdfsdsd
              </div>
            </li>
          </ul>
        </li>

      </ul>
      <div v-if="(inLoadingProcess||isLoadAll) && msgList.length" class="bottomLoading">
        {{bottomText}}
      </div>
    </div>

  </modal>
</template>

<script>
  import multiselect from 'vue-multiselect';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import Vue from 'vue'
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'

  export default {
    name: "message",
    data() {
      return {
        isShowList: true,
        //是否在请求消息列表的进程中
        inLoadingProcess: false,
        isLoadAll: false,
        //--------筛选条件-------
        //用户搜索的关键词

        keyword: "",
        pageSize: 20,
        pageNumber: 1,
        pageCount: 1,
        property: "title",


        //---------------------
        newMsgCount: 0,
        recentMsgList: [],
        //--------------------


        //state：1 新消息 0 已读
        msgList: [],
        //筛选的分类
        appInfo: null,
        appid: null,
        //筛选配置
        selectOptions: [],
        placeholder: "请选择应用名称",

      }

    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("message");
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      toggleLit() {
        this.isShowList = !this.isShowList;
      },
      async showDetail_BACK(msgId, msg) {
        this.toMsgDetailFlow(msg)
        if (!msg.read) {
          this.$emit("setNewMsgCount", {type: "minus"});
          msg.read = 1;
          let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_readMessage?msgId=" + msgId);
        }
      },
      async showDetail(msgId, msg, ev) {
        let msgContainer = ev.srcElement.parentNode
        if (ev.srcElement.tagName === 'LI') {
          msgContainer = msgContainer.parentNode
        }

        if (!msg.isShowContent) {
          msg.isShowContent = true
          msgContainer.querySelector('.msgContent').style.height = 'auto'
          msgContainer.querySelector('.msgContent').innerHTML = msg.content
          msgContainer.querySelector('.msgContent').style.transform = `scaleY(1)`
          msgContainer.querySelector('.msgContent').style.paddingTop = `10px`
          msgContainer.querySelector('.msgContent').style.paddingBottom = `10px`
          msgContainer.querySelector('.showContentBtn').style.transform = `scale(1.1)`
        } else {
          msg.isShowContent = false
          msgContainer.querySelector('.msgContent').style.height = '0'
          msgContainer.querySelector('.msgContent').style.transform = `scaleY(0)`
          msgContainer.querySelector('.msgContent').style.paddingTop = `0`
          msgContainer.querySelector('.msgContent').style.paddingBottom = `0`
          msgContainer.querySelector('.showContentBtn').style.transform = `scale(1)`
        }

        if (!msg.read) {
          this.$emit("setNewMsgCount", {type: "minus"});
          msg.read = 1;
          let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_readMessage?msgId=" + msgId);
        }
      },
      //进入消息详情流程
      toMsgDetailFlow(msg) {
        //Todo:消息进入详情分支数据处理：

        this.$modal.show('messageDetail', msg)
        return;
        switch (msg) {
          case 1:
            //日程

            break;
          case 2:
            //消息
            break;
          case 3:
            //通知公告
            break;
          case 4:
            //待办
            break;

        }
      },
      appSelect(selectedOption, id) {
        this.pageNumber = 1;
        this.msgList = [];
        console.log(selectedOption, id);
        this.appid = selectedOption.appid;
        this.appInfo = selectedOption;
        this.queryMsgList()
      },

      //全部标为已读
      async setAllSeen() {
        let res = await axios.post(apiConfig.REQUEST_URL + "/shall/front_readMessage?msgId=" + 0);
        if (res.data.status === 1) {
          this.$notify({
            group: 'global',
            title: '已全部设为已读',
          });
        }
        this.msgList.forEach((item, index) => {
          item.data.forEach((msgItem) => {
            msgItem.read = 1;
          })
        });
        this.$emit("setNewMsgCount", {type: "allSeen"});
      },
      //将新加载的消息列表push到旧的消息列表数据
      pushMsgToList(newData) {
        let oldLastItem = this.msgList[this.msgList.length - 1];
        newData.list.forEach((item, index) => {
          if (index === 0) {
            if (this.msgList.length) {
              if (item.year === oldLastItem.year && item.month === oldLastItem.month) {
                newData.list[0].data.forEach((item) => {
                  this.msgList[this.msgList.length - 1].data.push(item)
                });
                return;
              }
            }
          }
          this.msgList.push(item)
        });
        this.$nextTick(() => {
          this.inLoadingProcess = false;
        })
      },
      //查询消息列表
      async queryMsgList() {
        this.isLoadAll = false;

        let msgList = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getMessageHistory?" + this.$qs.stringify({
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
          property: this.property,
          keyword: encodeURIComponent(this.keyword),
          sysId: this.appInfo ? this.appInfo.appid : null
        })).catch((err) => {
          console.log(err)
        });
        this.inLoadingProcess = false;
        msgList = msgList.data.data[0];
        if (!msgList) {
          return
        }
        this.pageCount = msgList.pageCount;
        this.pageNumber = msgList.pageNumber;
        if (msgList.pageNumber >= msgList.pageCount) {
          this.isLoadAll = true;
        }
        if (!msgList.list.length) {
          //新取的消息为空
          return;
        }
        //取最新两条消息数据
        if (this.pageNumber === 1) {
          msgList.list.forEach((item, index) => {
            item.data.forEach((msgItem, msgIdx) => {
              if (this.recentMsgList.length >= 2) {
                return
              }
              this.recentMsgList.push(msgItem)
            })
          });
          this.$emit("refreshRecentMsg", this.recentMsgList)
        }

        this.pushMsgToList(msgList);


      },
      scrollToBottom() {
        this.inLoadingProcess = true;
        this.pageNumber++;
        this.queryMsgList();

      },
      // 初始化下拉加载
      msgListScroll() {
        let msgListContent = this.$refs.msgListContent;
        let currScrollTop = msgListContent.scrollTop;
        let maxScrollTop = msgListContent.scrollHeight - msgListContent.offsetHeight;
        let disToBottom = maxScrollTop - currScrollTop;
        console.log("disToBottom:", disToBottom);
        if (disToBottom <= 20 && (!this.inLoadingProcess)) {
          console.log("回调底部钩子");
          this.scrollToBottom();
        }
      },
      //筛选数据
      filterMsgList() {
        this.msgList = [];
        this.pageNumber = 1;
        this.pageCount = 1;

        this.queryMsgList()
      },

      //重置消息列表筛选器
      resetMsgFilter() {
        this.appInfo = "";
        this.keyword = "";
        this.filterMsgList();
      },
      //获取通知公告数据
      getNoticeItemData(noticeId) {
        return axios.post(apiConfig.REQUEST_URL + '/shall/front_getNotice?id=' + noticeId)
      },
      //去处理流程分支
      async toProfileVerifyHandle(msg) {
        let msgType = msg.type
        switch (msgType) {
          case 5:
            let msgId = parseInt(msg.messageId)
            this.$modal.show("verifyModal", {preData: msgId});
            return
          case 8:
            let noticeId = parseInt(msg.messageId)
            let noticeData = await this.getNoticeItemData(noticeId)
            if (!noticeData.data.status) {
              this.$notify({
                group: 'global',
                title: '温馨提示',
                text: noticeData.data.msg
              })
              return
            }
            noticeData = noticeData.data.data[0]
            if(noticeData.appOpenType=='window'){
              window.open(noticeData.url)
            }else{
              this.$modal.show("noticeDetail", {
                data: noticeData,
                title: noticeData.title,
                preData: noticeId,
                auditPower: true
              });
            }
            return
          default:
            console.log('消息类型异常')
        }
      }
    },


    computed: {
      ...mapState(['systemList']),
      bottomText() {
        let text = this.isLoadAll ? "已加载全部~" : "正在加载...";
        return text;
      }
    },
    components: {multiselect},
    mounted() {
      this.queryMsgList();
    }

  }
</script>

<style lang="stylus">
  @import "~common/stylus/config.styl"
    @keyframes pageLoading
      from
        transform scaleY(0)
        opacity 0

      to
        transform scaleY(1)
        opacity 1


    .messagebox
      background-color #ffffff

      p
        background-color #ffffff

        span
          border 1px solid #0f0
          float right

      .content
        height calc(100% - 50px)
        overflow-y scroll

        .search-container
          margin-top 20px
          margin-bottom 20px

          &::after
            content ""
            display block
            width 100%
            clear both

          .search
            text-align right
            float right
            font-size 0

            .multiselect
              width 152px
              height 30px
              margin-right 5px
              text-align left

            input
              width 152px
              height 30px
              border 1px solid #dddddd
              font-size 12px
              color #666666
              padding-left 10px
              margin-right 9px
              border-radius 15px

            button
              width 57px
              height 30px
              text-align center
              line-height 30px
              background-color #548edf
              border none
              outline none
              color #ffffff
              vertical-align top
              font-size 12px
              margin-right 4px
              border-radius 5px

              &.reset
                background-color #eea200

              &.allseen
                width 80px
                background-color #eea200

        .timeline-list
          transform-origin top center
          animation pageLoading 300ms
          padding-bottom 30px

          & > .empty
            font-size 16px
            line-height 80px
            text-align center
            color #666666

          & > li
            /*border 5px solid #f0f*/
            transition 300ms

            & > h3
              height 80px
              line-height 80px
              position relative

              & > span
                display inline-block
                height 100%
                position absolute

                &.year
                  width 134px
                  left 88px
                  color #548edf
                  font-size 20px

                &.month
                  left 220px
                  border-left 1px solid #f1f1f3
                  padding-left 38px
                  position relative
                  color #548edf
                  font-size 20px

                  & > span
                    margin-top 5px
                    display inline-block
                    width 32px
                    height 40px
                    position absolute
                    left -16px
                    top 0
                    text-align center
                    color #548edf
                    background-color #ffffff

                    i
                      line-height 40px
                      font-size 30px

            & > ul
              & > li
                min-height 64px
                position relative

                &::after
                  content ""
                  display block
                  width 100%
                  clear both

                &:hover .info, &:hover p
                  transition 300ms
                  background-color #f1f1f1

                & > div
                  width 221px
                  height 100%
                  float left
                  position relative
                  padding-right 40px
                  border-right 1px solid #f1f1f3
                  padding-top 5px

                  p
                    line-height 28px
                    font-size 14px
                    color #999999
                    text-align right

                  & > span
                    position absolute
                    right -9px
                    top 0
                    bottom 0
                    margin auto
                    display block
                    width 16px
                    height 16px
                    border 2px solid #548edf
                    border-radius 50%
                    background-color #ffffff

                & > p
                  font-size 14px
                  color #666666
                  line-height 61px
                  padding-left 40px
                  text-overflow ellipsis
                  white-space nowrap
                  overflow hidden
                  padding-right 240px
                  transition 300ms
                  cursor pointer

                  &:hover
                    color #333333 !important

                &.seen p
                  color #cccccc

                & > ul
                  width 240px
                  position absolute
                  right 0
                  top 0

                  & > li
                    display inline-block
                    line-height 64px
                    font-size 14px
                    color #548edf
                    padding 0 5px
                    cursor pointer
                    transition 300ms
                    user-select none

                    &:hover
                      color #13d0ff

                    &.interact
                      color #60bf25

                      &:hover
                        color #87e028

                .msgContent
                  width 100%
                  clear both
                  overflow hidden
                  margin 0
                  height 0
                  border 1px solid #eeeeee
                  font-size 14px
                  color #666666
                  padding 0 20px
                  transition 300ms
                  transform-origin top center
                  transform scaleY(0)
                  text-indent 2em

        .bottomLoading
          text-align center
          color #666666
          font-size 14px
          line-height 28px

</style>



// WEBPACK FOOTER //
// src/components/message/messageModal.vue